export const UnsubscribeIcon = () => (
  <svg
    width="42"
    height="40"
    viewBox="0 0 42 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 40C13.8125 40 7.25 36.25 3.65625 30C0.0625 23.8281 0.0625 16.25 3.65625 10C7.25 3.82812 13.8125 0 21 0C28.1094 0 34.6719 3.82812 38.2656 10C41.8594 16.25 41.8594 23.8281 38.2656 30C34.6719 36.25 28.1094 40 21 40ZM14.6719 13.6719C13.8906 14.4531 13.8906 15.625 14.6719 16.3281L18.3438 20L14.6719 23.6719C13.8906 24.4531 13.8906 25.625 14.6719 26.3281C15.375 27.1094 16.5469 27.1094 17.25 26.3281L20.9219 22.6562L24.5938 26.3281C25.375 27.1094 26.5469 27.1094 27.25 26.3281C28.0312 25.625 28.0312 24.4531 27.25 23.6719L23.5781 20L27.25 16.3281C28.0312 15.625 28.0312 14.4531 27.25 13.6719C26.5469 12.9688 25.375 12.9688 24.5938 13.6719L20.9219 17.3438L17.25 13.6719C16.5469 12.9688 15.375 12.9688 14.6719 13.6719Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const NoMembershipIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <foreignObject x="-11.907" y="-11.907" width="87.814" height="87.814">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(5.95px)",
          clipPath: "url(#bgblur_1_7705_2667_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g datafigmabgblurradius="11.907">
      <g clipPath="url(#clip0_7705_2667)">
        <rect width="64" height="64" rx="8" fill="#D3DBE9" />
        <g filter="url(#filter1_d_7705_2667)">
          <g filter="url(#filter2_dii_7705_2667)">
            <path
              d="M52.0976 48.1561C51.759 49.9687 50.3409 51.3867 48.5283 51.7253L44.2468 52.5251C43.4025 52.6829 42.6216 53.0807 41.9978 53.6711L38.8341 56.6648C37.4947 57.9322 35.514 58.2459 33.8486 57.4544L29.9146 55.5849C29.1389 55.2162 28.2732 55.0791 27.4216 55.19L23.1024 55.7524C21.2739 55.9904 19.4871 55.08 18.6049 53.4608L16.5211 49.636C16.1102 48.8817 15.4905 48.262 14.7363 47.8511L10.9115 45.7674C9.29225 44.8852 8.38184 43.0984 8.61992 41.2699L9.18229 36.9507C9.29318 36.099 9.15608 35.2334 8.78743 34.4577L6.91789 30.5237C6.12642 28.8582 6.44013 26.8776 7.70752 25.5382L10.7012 22.3745C11.2915 21.7506 11.6894 20.9698 11.8471 20.1255L12.647 15.8439C12.9856 14.0313 14.4036 12.6133 16.2162 12.2747L20.4978 11.4749C21.342 11.3171 22.1229 10.9193 22.7468 10.3289L25.9105 7.33524C27.2498 6.06785 29.2305 5.75414 30.896 6.54561L34.83 8.41514C35.6057 8.7838 36.4713 8.9209 37.323 8.81001L41.6422 8.24764C43.4707 8.00955 45.2575 8.91997 46.1396 10.5392L48.2234 14.364C48.6343 15.1183 49.254 15.738 50.0082 16.1489L53.8331 18.2326C55.4523 19.1148 56.3627 20.9016 56.1246 22.7301L55.5623 27.0493C55.4514 27.901 55.5885 28.7666 55.9571 29.5423L57.8267 33.4763C58.6181 35.1418 58.3044 37.1224 57.037 38.4618L54.0433 41.6255C53.453 42.2494 53.0551 43.0302 52.8974 43.8745L52.0976 48.1561Z"
              fill="url(#paint0_linear_7705_2667)"
            />
          </g>
          <path
            d="M43.7891 21.4922C45.454 21.4929 46.8051 22.8426 46.8057 24.5078V39.4844C46.8054 41.1497 45.4542 42.5003 43.7891 42.501H20.2119C18.5463 42.5008 17.1956 41.1499 17.1953 39.4844V24.5078C17.1958 22.8423 18.5466 21.4924 20.2119 21.4922H43.7891ZM26.4941 26.0527C26.1348 26.0529 25.8031 26.2194 25.5811 26.5146L25.4932 26.6484L24.1934 28.9248L24.1123 29.0654L23.9551 29.1025L21.4688 29.6826C21.0669 29.7765 20.7445 30.0763 20.6123 30.498C20.4806 30.9204 20.5713 31.3675 20.8496 31.6963L22.5312 33.6836L22.6318 33.8018L22.6182 33.957L22.3818 36.5928C22.3425 37.0349 22.5261 37.4489 22.8643 37.7041C23.2017 37.9581 23.6236 38.0072 24.002 37.8369V37.8359L26.3418 36.7881L26.4941 36.7207L26.6465 36.7881L28.9873 37.8359V37.8369C29.1368 37.9041 29.2939 37.9354 29.4463 37.9355C29.6834 37.9347 29.9206 37.8591 30.126 37.7041C30.4216 37.481 30.5982 37.1359 30.6113 36.7568L30.6064 36.5928L30.3701 33.957L30.3564 33.8018L30.457 33.6836L32.1396 31.6963C32.4183 31.367 32.5086 30.92 32.377 30.498C32.2448 30.077 31.9219 29.7766 31.5205 29.6826L29.0342 29.1025L28.877 29.0654L28.7959 28.9248L27.4961 26.6484C27.2798 26.2708 26.9045 26.0531 26.4941 26.0527ZM35.6367 36.6865C35.3063 36.6867 35.0383 36.9547 35.0381 37.2852C35.0381 37.6158 35.3062 37.8836 35.6367 37.8838H43.001C43.3315 37.8835 43.5996 37.6157 43.5996 37.2852C43.5994 36.9547 43.3314 36.6868 43.001 36.6865H35.6367ZM35.6396 33.6826C35.3092 33.6828 35.0412 33.9508 35.041 34.2812C35.0413 34.6116 35.3093 34.8797 35.6396 34.8799H43.0039C43.3341 34.8795 43.6023 34.6115 43.6025 34.2812C43.6024 33.9509 43.3342 33.683 43.0039 33.6826H35.6396ZM36.4023 26.3018C35.6652 26.302 35.0655 26.8818 35.0654 27.5938V30.0576C35.0658 30.7693 35.6654 31.3494 36.4023 31.3496H42.208C42.9446 31.3491 43.5446 30.7691 43.5449 30.0576V27.5938C43.5449 26.8821 42.9448 26.3023 42.208 26.3018H36.4023Z"
            fill="#B8C3D6"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath
        id="bgblur_1_7705_2667_clip_path"
        transform="translate(11.907 11.907)"
      >
        <rect width="64" height="64" rx="8" />
      </clipPath>
      <filter
        id="filter1_d_7705_2667"
        x="-3.72088"
        y="-0.746094"
        width="71.4418"
        height="71.4418"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.97674" />
        <feGaussianBlur stdDeviation="1.48837" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7705_2667"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7705_2667"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dii_7705_2667"
        x="0.334165"
        y="-0.0388823"
        width="83.2178"
        height="83.2178"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="9.57003" dy="9.57003" />
        <feGaussianBlur stdDeviation="7.8611" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7705_2667"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7705_2667"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.73429" dy="-2.73429" />
        <feGaussianBlur stdDeviation="6.49395" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.400213 0 0 0 0 0.631606 0 0 0 0 0.677885 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_7705_2667"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="6.83574" dy="6.83574" />
        <feGaussianBlur stdDeviation="4.44323" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_7705_2667"
          result="effect3_innerShadow_7705_2667"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7705_2667"
        x1="13.2088"
        y1="51.1635"
        x2="51.5357"
        y2="12.8365"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#EDF0F6" />
      </linearGradient>
      <clipPath id="clip0_7705_2667">
        <rect width="64" height="64" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SuccessCheckIcon = () => (
  <svg
    width="42"
    height="40"
    viewBox="0 0 42 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9375 40C13.75 40 7.1875 36.25 3.59375 30C0 23.8281 0 16.25 3.59375 10C7.1875 3.82812 13.75 0 20.9375 0C28.0469 0 34.6094 3.82812 38.2031 10C41.7969 16.25 41.7969 23.8281 38.2031 30C34.6094 36.25 28.0469 40 20.9375 40ZM29.7656 16.3281H29.6875C30.4688 15.625 30.4688 14.4531 29.6875 13.6719C28.9844 12.9688 27.8125 12.9688 27.1094 13.6719L18.4375 22.4219L14.7656 18.75C13.9844 17.9688 12.8125 17.9688 12.1094 18.75C11.3281 19.4531 11.3281 20.625 12.1094 21.3281L17.1094 26.3281C17.8125 27.1094 18.9844 27.1094 19.7656 26.3281L29.7656 16.3281Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const MembrshipInLoyaltyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <foreignObject x="-11.907" y="-11.907" width="87.814" height="87.814">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(5.95px)",
          clipPath: "url(#bgblur_1_7551_2315_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g datafigmabgblurradius="11.907">
      <g clipPath="url(#clip0_7551_2315)">
        <rect width="64" height="64" rx="8" fill="#92ABB0" />
        <rect
          width="64"
          height="64"
          rx="8"
          fill="#4DAABD"
          fillOpacity="0.6"
          style={{ mixBlendMode: "colorBurn" }}
        />
        <g filter="url(#filter1_d_7551_2315)">
          <g filter="url(#filter2_dii_7551_2315)">
            <path
              d="M52.0976 48.1561C51.759 49.9687 50.3409 51.3867 48.5283 51.7253L44.2468 52.5251C43.4025 52.6829 42.6216 53.0807 41.9978 53.6711L38.8341 56.6648C37.4947 57.9322 35.514 58.2459 33.8486 57.4544L29.9146 55.5849C29.1389 55.2162 28.2732 55.0791 27.4216 55.19L23.1024 55.7524C21.2739 55.9904 19.4871 55.08 18.6049 53.4608L16.5211 49.636C16.1102 48.8817 15.4905 48.262 14.7363 47.8511L10.9115 45.7674C9.29225 44.8852 8.38184 43.0984 8.61992 41.2699L9.18229 36.9507C9.29318 36.099 9.15608 35.2334 8.78743 34.4577L6.91789 30.5237C6.12642 28.8582 6.44013 26.8776 7.70752 25.5382L10.7012 22.3745C11.2915 21.7506 11.6894 20.9698 11.8471 20.1255L12.647 15.8439C12.9856 14.0313 14.4036 12.6133 16.2162 12.2747L20.4978 11.4749C21.342 11.3171 22.1229 10.9193 22.7468 10.3289L25.9105 7.33524C27.2498 6.06785 29.2305 5.75414 30.896 6.54561L34.83 8.41514C35.6057 8.7838 36.4713 8.9209 37.323 8.81001L41.6422 8.24764C43.4707 8.00955 45.2575 8.91997 46.1396 10.5392L48.2234 14.364C48.6343 15.1183 49.254 15.738 50.0082 16.1489L53.8331 18.2326C55.4523 19.1148 56.3627 20.9016 56.1246 22.7301L55.5623 27.0493C55.4514 27.901 55.5885 28.7666 55.9571 29.5423L57.8267 33.4763C58.6181 35.1418 58.3044 37.1224 57.037 38.4618L54.0433 41.6255C53.453 42.2494 53.0551 43.0302 52.8974 43.8745L52.0976 48.1561Z"
              fill="url(#paint0_linear_7551_2315)"
            />
          </g>
          <g filter="url(#filter3_ii_7551_2315)">
            <path
              d="M43.7891 21.4922C45.454 21.4929 46.8051 22.8426 46.8057 24.5078V39.4844C46.8054 41.1497 45.4542 42.5003 43.7891 42.501H20.2119C18.5463 42.5008 17.1956 41.1499 17.1953 39.4844V24.5078C17.1958 22.8423 18.5466 21.4924 20.2119 21.4922H43.7891ZM26.4941 26.0527C26.1348 26.0529 25.8031 26.2194 25.5811 26.5146L25.4932 26.6484L24.1934 28.9248L24.1123 29.0654L23.9551 29.1025L21.4688 29.6826C21.0669 29.7765 20.7445 30.0763 20.6123 30.498C20.4806 30.9204 20.5713 31.3675 20.8496 31.6963L22.5312 33.6836L22.6318 33.8018L22.6182 33.957L22.3818 36.5928C22.3425 37.0349 22.5261 37.4489 22.8643 37.7041C23.2017 37.9581 23.6236 38.0072 24.002 37.8369V37.8359L26.3418 36.7881L26.4941 36.7207L26.6465 36.7881L28.9873 37.8359V37.8369C29.1368 37.9041 29.2939 37.9354 29.4463 37.9355C29.6834 37.9347 29.9206 37.8591 30.126 37.7041C30.4216 37.481 30.5982 37.1359 30.6113 36.7568L30.6064 36.5928L30.3701 33.957L30.3564 33.8018L30.457 33.6836L32.1396 31.6963C32.4183 31.367 32.5086 30.92 32.377 30.498C32.2448 30.077 31.9219 29.7766 31.5205 29.6826L29.0342 29.1025L28.877 29.0654L28.7959 28.9248L27.4961 26.6484C27.2798 26.2708 26.9045 26.0531 26.4941 26.0527ZM35.6367 36.6865C35.3063 36.6867 35.0383 36.9547 35.0381 37.2852C35.0381 37.6158 35.3062 37.8836 35.6367 37.8838H43.001C43.3315 37.8835 43.5996 37.6157 43.5996 37.2852C43.5994 36.9547 43.3314 36.6868 43.001 36.6865H35.6367ZM35.6396 33.6826C35.3092 33.6828 35.0412 33.9508 35.041 34.2812C35.0413 34.6116 35.3093 34.8797 35.6396 34.8799H43.0039C43.3341 34.8795 43.6023 34.6115 43.6025 34.2812C43.6024 33.9509 43.3342 33.683 43.0039 33.6826H35.6396ZM36.4023 26.3018C35.6652 26.302 35.0655 26.8818 35.0654 27.5938V30.0576C35.0658 30.7693 35.6654 31.3494 36.4023 31.3496H42.208C42.9446 31.3491 43.5446 30.7691 43.5449 30.0576V27.5938C43.5449 26.8821 42.9448 26.3023 42.208 26.3018H36.4023Z"
              fill="url(#paint1_linear_7551_2315)"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath
        id="bgblur_1_7551_2315_clip_path"
        transform="translate(11.907 11.907)"
      >
        <rect width="64" height="64" rx="8" />
      </clipPath>
      <filter
        id="filter1_d_7551_2315"
        x="-3.72088"
        y="-0.746094"
        width="71.4418"
        height="71.4418"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.97674" />
        <feGaussianBlur stdDeviation="1.48837" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7551_2315"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7551_2315"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dii_7551_2315"
        x="0.334165"
        y="-0.0388823"
        width="83.2178"
        height="83.2178"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="9.57003" dy="9.57003" />
        <feGaussianBlur stdDeviation="7.8611" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7551_2315"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7551_2315"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.73429" dy="-2.73429" />
        <feGaussianBlur stdDeviation="6.49395" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.400213 0 0 0 0 0.631606 0 0 0 0 0.677885 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_7551_2315"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="6.83574" dy="6.83574" />
        <feGaussianBlur stdDeviation="4.44323" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_7551_2315"
          result="effect3_innerShadow_7551_2315"
        />
      </filter>
      <filter
        id="filter3_ii_7551_2315"
        x="15.1637"
        y="19.4606"
        width="33.6726"
        height="25.0711"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2.03163" dy="2.03163" />
        <feGaussianBlur stdDeviation="3.04744" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_7551_2315"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.03163" dy="-2.03163" />
        <feGaussianBlur stdDeviation="3.04744" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.168846 0 0 0 0 0.38844 0 0 0 0 0.4 0 0 0 0.39 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_7551_2315"
          result="effect2_innerShadow_7551_2315"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7551_2315"
        x1="13.2088"
        y1="51.1635"
        x2="51.5357"
        y2="12.8365"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#EDF0F6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7551_2315"
        x1="32.0005"
        y1="21.4766"
        x2="36.7251"
        y2="41.3962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
      <clipPath id="clip0_7551_2315">
        <rect width="64" height="64" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StarIcon = ({ fill = "#B8C3D6" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill={fill} />
    <path
      d="M12.5469 7.10156L13.8164 9.69922L16.6094 10.1094C16.8438 10.1484 17.0391 10.3047 17.1172 10.5391C17.1953 10.7539 17.1367 11.0078 16.9609 11.1641L14.9297 13.1758L15.418 16.0273C15.457 16.2617 15.3594 16.4961 15.1641 16.6328C14.9688 16.7891 14.7148 16.7891 14.5 16.6914L12 15.3438L9.48047 16.6914C9.28516 16.7891 9.03125 16.7891 8.83594 16.6328C8.64062 16.4961 8.54297 16.2617 8.58203 16.0273L9.05078 13.1758L7.01953 11.1641C6.86328 11.0078 6.80469 10.7539 6.86328 10.5391C6.94141 10.3047 7.13672 10.1484 7.37109 10.1094L10.1836 9.69922L11.4336 7.10156C11.5312 6.88672 11.7461 6.75 12 6.75C12.2344 6.75 12.4492 6.88672 12.5469 7.10156Z"
      fill="white"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 1.625C2.75 1.16016 3.13281 0.75 3.625 0.75C4.08984 0.75 4.5 1.16016 4.5 1.625V2.5H8V1.625C8 1.16016 8.38281 0.75 8.875 0.75C9.33984 0.75 9.75 1.16016 9.75 1.625V2.5H11.0625C11.7734 2.5 12.375 3.10156 12.375 3.8125V5.125H0.125V3.8125C0.125 3.10156 0.699219 2.5 1.4375 2.5H2.75V1.625ZM12.375 6V6.02734C12.2109 6.02734 12.0742 6 11.9375 6C9.25781 6 7.125 8.16016 7.125 10.8125C7.125 12.4531 7.91797 13.9023 9.14844 14.75H1.4375C0.699219 14.75 0.125 14.1758 0.125 13.4375V6H11.9375H12.375ZM15.875 10.8125C15.875 12.2344 15.1094 13.5195 13.9062 14.2305C12.6758 14.9414 11.1719 14.9414 9.96875 14.2305C8.73828 13.5195 8 12.2344 8 10.8125C8 9.41797 8.73828 8.13281 9.96875 7.42188C11.1719 6.71094 12.6758 6.71094 13.9062 7.42188C15.1094 8.13281 15.875 9.41797 15.875 10.8125ZM11.9375 8.625C11.6914 8.625 11.5 8.84375 11.5 9.0625V10.8125C11.5 11.0586 11.6914 11.25 11.9375 11.25H13.25C13.4688 11.25 13.6875 11.0586 13.6875 10.8125C13.6875 10.5938 13.4688 10.375 13.25 10.375H12.375V9.0625C12.375 8.84375 12.1562 8.625 11.9375 8.625Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const CouponIcon = () => (
  <svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 3.25C4.25 1.88281 5.34375 0.75 6.75 0.75H23C24.3672 0.75 25.5 1.88281 25.5 3.25V5.125C25.5 5.47656 25.1875 5.75 24.875 5.86719C24.1328 6.14062 23.625 6.80469 23.625 7.625C23.625 8.44531 24.1328 9.14844 24.875 9.42188C25.1875 9.53906 25.5 9.8125 25.5 10.125V12C25.5 13.4062 24.3672 14.5 23 14.5H6.75C5.34375 14.5 4.25 13.4062 4.25 12V10.125C4.25 9.8125 4.52344 9.53906 4.83594 9.42188C5.57812 9.14844 6.125 8.44531 6.125 7.625C6.125 6.80469 5.57812 6.14062 4.83594 5.86719C4.52344 5.75 4.25 5.47656 4.25 5.125V3.25ZM20.5 4.5V10.75H9.25V4.5H20.5ZM9.25 3.25C8.54688 3.25 8 3.83594 8 4.5V10.75C8 11.4531 8.54688 12 9.25 12H20.5C21.1641 12 21.75 11.4531 21.75 10.75V4.5C21.75 3.83594 21.1641 3.25 20.5 3.25H9.25ZM2.375 4.1875V13.5625C2.375 15.125 3.625 16.375 5.1875 16.375H20.8125C21.3203 16.375 21.75 16.8047 21.75 17.3125C21.75 17.8594 21.3203 18.25 20.8125 18.25H5.1875C2.57031 18.25 0.5 16.1797 0.5 13.5625V4.1875C0.5 3.67969 0.890625 3.25 1.4375 3.25C1.94531 3.25 2.375 3.67969 2.375 4.1875Z"
      fill="url(#paint0_linear_7242_13108)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7242_13108"
        x1="13"
        y1="-5"
        x2="13"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const DiscountIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0.5C11.4062 0.5 12.6562 1.32031 13.2812 2.53125C14.5703 2.10156 16.0547 2.41406 17.0703 3.42969C18.0859 4.44531 18.3984 5.92969 17.9688 7.21875C19.1797 7.84375 20 9.09375 20 10.5C20 11.9453 19.1797 13.1953 17.9688 13.8203C18.3984 15.1094 18.0859 16.5547 17.0703 17.5703C16.0547 18.5859 14.5703 18.8984 13.2812 18.5078C12.6562 19.7188 11.4062 20.5 10 20.5C8.55469 20.5 7.30469 19.7188 6.67969 18.5078C5.39062 18.8984 3.94531 18.5859 2.92969 17.5703C1.91406 16.5547 1.60156 15.1094 1.99219 13.8203C0.78125 13.1953 0 11.9453 0 10.5C0 9.09375 0.78125 7.84375 1.99219 7.21875C1.60156 5.92969 1.91406 4.44531 2.92969 3.42969C3.94531 2.41406 5.39062 2.10156 6.67969 2.53125C7.30469 1.32031 8.55469 0.5 10 0.5ZM7.5 9.25C8.16406 9.25 8.75 8.70312 8.75 8C8.75 7.33594 8.16406 6.75 7.5 6.75C6.79688 6.75 6.25 7.33594 6.25 8C6.25 8.70312 6.79688 9.25 7.5 9.25ZM13.75 13C13.75 12.3359 13.1641 11.75 12.5 11.75C11.7969 11.75 11.25 12.3359 11.25 13C11.25 13.7031 11.7969 14.25 12.5 14.25C13.1641 14.25 13.75 13.7031 13.75 13ZM13.1641 8.66406C13.5156 8.3125 13.5156 7.72656 13.1641 7.375C12.7734 6.98438 12.1875 6.98438 11.8359 7.375L6.83594 12.3359C6.44531 12.7266 6.44531 13.3125 6.83594 13.6641C7.1875 14.0547 7.77344 14.0547 8.125 13.6641L13.1641 8.66406Z"
      fill="url(#paint0_linear_7242_15467)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7242_15467"
        x1="10"
        y1="-4"
        x2="10"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const CustomPriceIcon = () => (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4766 1.0625L18.4375 6.10156C20.5078 8.17188 20.5078 11.4922 18.4375 13.5625L14.0625 17.9766C13.7109 18.3672 13.125 18.3672 12.7344 18.0156C12.3828 17.625 12.3828 17.0391 12.7344 16.6875L17.1094 12.2344C18.4375 10.9062 18.4375 8.75781 17.1094 7.42969L12.1094 2.35156C11.7578 2 11.7578 1.41406 12.1484 1.02344C12.5 0.671875 13.0859 0.671875 13.4766 1.0625ZM0 8.48438V2.625C0 1.60938 0.820312 0.75 1.875 0.75H7.69531C8.35938 0.75 8.98438 1.02344 9.45312 1.49219L16.0156 8.05469C16.9922 9.03125 16.9922 10.6328 16.0156 11.6094L10.8203 16.8047C9.84375 17.7812 8.24219 17.7812 7.26562 16.8047L0.703125 10.2422C0.234375 9.77344 0 9.14844 0 8.48438ZM5.625 5.125C5.625 4.46094 5.03906 3.875 4.375 3.875C3.67188 3.875 3.125 4.46094 3.125 5.125C3.125 5.82812 3.67188 6.375 4.375 6.375C5.03906 6.375 5.625 5.82812 5.625 5.125Z"
      fill="url(#paint0_linear_7242_11807)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7242_11807"
        x1="10"
        y1="-5"
        x2="10"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const IncludedIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0.5C11.4062 0.5 12.6562 1.32031 13.2812 2.53125C14.5703 2.10156 16.0547 2.41406 17.0703 3.42969C18.0859 4.44531 18.3984 5.92969 17.9688 7.21875C19.1797 7.84375 20 9.09375 20 10.5C20 11.9453 19.1797 13.1953 17.9688 13.8203C18.3984 15.1094 18.0859 16.5547 17.0703 17.5703C16.0547 18.5859 14.5703 18.8984 13.2812 18.5078C12.6562 19.7188 11.4062 20.5 10 20.5C8.55469 20.5 7.30469 19.7188 6.67969 18.5078C5.39062 18.8984 3.94531 18.5859 2.92969 17.5703C1.91406 16.5547 1.60156 15.1094 1.99219 13.8203C0.78125 13.1953 0 11.9453 0 10.5C0 9.09375 0.78125 7.84375 1.99219 7.21875C1.60156 5.92969 1.91406 4.44531 2.92969 3.42969C3.94531 2.41406 5.39062 2.10156 6.67969 2.53125C7.30469 1.32031 8.55469 0.5 10 0.5ZM14.4141 8.66406C14.7656 8.3125 14.7656 7.72656 14.4141 7.375C14.0234 6.98438 13.4375 6.98438 13.0859 7.375L8.75 11.7109L6.91406 9.875C6.52344 9.48438 5.9375 9.48438 5.58594 9.875C5.19531 10.2266 5.19531 10.8125 5.58594 11.1641L8.08594 13.6641C8.4375 14.0547 9.02344 14.0547 9.41406 13.6641L14.4141 8.66406Z"
      fill="url(#paint0_linear_7242_13263)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7242_13263"
        x1="10"
        y1="-4"
        x2="10"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const MemberShipUsersIcon = () => (
  <svg
    width="50"
    height="40"
    viewBox="0 0 50 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 0C13.4375 0 15.4688 1.25 16.6406 3.125C17.7344 5.07812 17.7344 7.5 16.6406 9.375C15.4688 11.3281 13.4375 12.5 11.25 12.5C8.98438 12.5 6.95312 11.3281 5.78125 9.375C4.6875 7.5 4.6875 5.07812 5.78125 3.125C6.95312 1.25 8.98438 0 11.25 0ZM40 0C42.1875 0 44.2188 1.25 45.3906 3.125C46.4844 5.07812 46.4844 7.5 45.3906 9.375C44.2188 11.3281 42.1875 12.5 40 12.5C37.7344 12.5 35.7031 11.3281 34.5312 9.375C33.4375 7.5 33.4375 5.07812 34.5312 3.125C35.7031 1.25 37.7344 0 40 0ZM0 23.3594C0 18.75 3.67188 15 8.28125 15H11.6406C12.8906 15 14.0625 15.3125 15.1562 15.7812C15 16.3281 15 16.9531 15 17.5C15 20.5469 16.25 23.2031 18.3594 25C18.3594 25 18.3594 25 18.2812 25H1.64062C0.703125 25 0 24.2969 0 23.3594ZM31.6406 25H31.5625C33.6719 23.2031 34.9219 20.5469 34.9219 17.5C34.9219 16.9531 34.9219 16.3281 34.8438 15.7812C35.8594 15.3125 37.0312 15 38.2812 15H41.6406C46.25 15 50 18.75 50 23.3594C50 24.2969 49.2188 25 48.2812 25H31.6406ZM17.5 17.5C17.5 14.8438 18.9062 12.4219 21.25 11.0156C23.5156 9.6875 26.4062 9.6875 28.75 11.0156C31.0156 12.4219 32.5 14.8438 32.5 17.5C32.5 20.2344 31.0156 22.6562 28.75 24.0625C26.4062 25.3906 23.5156 25.3906 21.25 24.0625C18.9062 22.6562 17.5 20.2344 17.5 17.5ZM10 37.9688C10 32.1875 14.6094 27.5 20.3906 27.5H29.5312C35.3125 27.5 40 32.1875 40 37.9688C40 39.0625 39.0625 40 37.8906 40H12.0312C10.9375 40 10 39.1406 10 37.9688Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const ContactPhoneIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.84375 1.08594L4.78125 3.33594C4.94531 3.71094 4.85156 4.15625 4.52344 4.41406L3.375 5.375C4.14844 7.01562 5.48438 8.35156 7.125 9.125L8.08594 7.97656C8.34375 7.64844 8.78906 7.55469 9.16406 7.71875L11.4141 8.65625C11.8594 8.82031 12.0703 9.3125 11.9531 9.75781L11.3906 11.8203C11.2734 12.2188 10.9219 12.5 10.5 12.5C4.6875 12.5 0 7.8125 0 2C0 1.57812 0.28125 1.22656 0.679688 1.10938L2.74219 0.546875C3.1875 0.429688 3.67969 0.640625 3.84375 1.08594Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const ContactEmailIcon = () => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.125 0H10.875C11.4844 0 12 0.515625 12 1.125C12 1.5 11.8125 1.82812 11.5312 2.03906L6.44531 5.85938C6.16406 6.07031 5.8125 6.07031 5.53125 5.85938L0.445312 2.03906C0.164062 1.82812 0 1.5 0 1.125C0 0.515625 0.492188 0 1.125 0ZM0 2.625L5.08594 6.46875C5.625 6.86719 6.35156 6.86719 6.89062 6.46875L12 2.625V7.5C12 8.34375 11.3203 9 10.5 9H1.5C0.65625 9 0 8.34375 0 7.5V2.625Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const EditAction = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.7969 1.71875L38.2812 3.20312C40 4.92188 40 7.65625 38.2812 9.375L35.9375 11.7188L28.2812 4.0625L30.625 1.71875C32.3438 0 35.0781 0 36.7969 1.71875ZM13.4375 18.9062L26.4844 5.85938L34.1406 13.5156L21.0938 26.5625C20.625 27.0312 20 27.4219 19.375 27.6562L12.4219 29.9219C11.7969 30.1562 11.0156 30 10.5469 29.4531C10 28.9844 9.84375 28.2031 10.0781 27.5781L12.3438 20.625C12.5781 20 12.9688 19.375 13.4375 18.9062ZM7.5 5H15C16.3281 5 17.5 6.17188 17.5 7.5C17.5 8.90625 16.3281 10 15 10H7.5C6.09375 10 5 11.1719 5 12.5V32.5C5 33.9062 6.09375 35 7.5 35H27.5C28.8281 35 30 33.9062 30 32.5V25C30 23.6719 31.0938 22.5 32.5 22.5C33.8281 22.5 35 23.6719 35 25V32.5C35 36.6406 31.6406 40 27.5 40H7.5C3.35938 40 0 36.6406 0 32.5V12.5C0 8.35938 3.35938 5 7.5 5Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const DeleteAction = () => (
  <svg
    width="36"
    height="40"
    viewBox="0 0 36 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0469 1.40625C11.4375 0.546875 12.2969 0 13.2344 0H22.6875C23.625 0 24.4844 0.546875 24.875 1.40625L25.5 2.5H33C34.3281 2.5 35.5 3.67188 35.5 5C35.5 6.40625 34.3281 7.5 33 7.5H3C1.59375 7.5 0.5 6.40625 0.5 5C0.5 3.67188 1.59375 2.5 3 2.5H10.5L11.0469 1.40625ZM33 10L31.2812 36.4844C31.2031 38.5156 29.5625 40 27.5312 40H8.39062C6.35938 40 4.71875 38.5156 4.64062 36.4844L3 10H33Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const MembershipCardIcon = () => (
  <svg
    width="54"
    height="42"
    viewBox="0 0 54 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0H48C51.2812 0 54 2.71875 54 6V36C54 39.375 51.2812 42 48 42H6C2.625 42 0 39.375 0 36V6C0 2.71875 2.625 0 6 0ZM13.5 24C9.28125 24 6 27.375 6 31.5C6 32.3438 6.65625 33 7.5 33H25.5C26.25 33 27 32.3438 27 31.5C27 27.375 23.625 24 19.5 24H13.5ZM10.5 15C10.5 17.1562 11.625 19.125 13.5 20.25C15.2812 21.2812 17.625 21.2812 19.5 20.25C21.2812 19.125 22.5 17.1562 22.5 15C22.5 12.9375 21.2812 10.9688 19.5 9.84375C17.625 8.8125 15.2812 8.8125 13.5 9.84375C11.625 10.9688 10.5 12.9375 10.5 15ZM34.5 12C33.6562 12 33 12.75 33 13.5C33 14.3438 33.6562 15 34.5 15H46.5C47.25 15 48 14.3438 48 13.5C48 12.75 47.25 12 46.5 12H34.5ZM34.5 18C33.6562 18 33 18.75 33 19.5C33 20.3438 33.6562 21 34.5 21H46.5C47.25 21 48 20.3438 48 19.5C48 18.75 47.25 18 46.5 18H34.5ZM34.5 24C33.6562 24 33 24.75 33 25.5C33 26.3438 33.6562 27 34.5 27H46.5C47.25 27 48 26.3438 48 25.5C48 24.75 47.25 24 46.5 24H34.5Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const CardChipIcon = () => (
  <svg
    width="32"
    height="26"
    viewBox="0 0 32 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.9982 26H3.00178C1.35318 26 0 24.6073 0 22.9106V3.0894C0 1.39268 1.35318 0 3.00178 0H28.9982C30.6468 0 31.9999 1.39268 31.9999 3.0894V22.9106C32.0095 24.6171 30.6563 26 28.9982 26Z"
      fill="#F6C859"
    />
    <path
      d="M12.3209 22.537C12.1874 22.537 12.054 22.4585 11.9873 22.331C11.892 22.1447 11.9683 21.9093 12.1493 21.821C12.683 21.5366 13.4167 21.007 13.836 20.0851C14.3697 18.918 14.2363 17.6528 14.0076 17.5449C13.9504 17.5155 13.7217 17.6332 13.5883 17.7116C13.2357 17.898 12.7592 18.153 12.197 17.947C11.6443 17.7509 11.3774 17.2507 11.2536 17.0055C10.415 15.4265 10.1577 11.3073 11.0439 9.25747C11.3393 8.58074 11.7396 8.17863 12.2351 8.06094C12.7401 7.94325 13.1499 8.15901 13.4834 8.33555C13.7598 8.48267 13.8932 8.54151 13.979 8.49247C14.322 8.27671 14.3125 6.97229 13.836 5.93268C13.4167 5.01077 12.683 4.48116 12.1493 4.19673C11.9683 4.09866 11.892 3.87308 11.9873 3.68674C12.0826 3.50039 12.3018 3.42193 12.4829 3.52001C13.1213 3.85347 13.9885 4.49096 14.5031 5.59922C15.0082 6.69768 15.2464 8.59055 14.3602 9.13978C13.9123 9.41439 13.4834 9.18881 13.1404 9.01228C12.8831 8.87497 12.6353 8.74747 12.3971 8.80632C12.0731 8.88478 11.8444 9.26728 11.711 9.58112C10.9391 11.3661 11.1583 15.2597 11.892 16.6524C12.0159 16.8878 12.1684 17.1428 12.4257 17.2409C12.6734 17.3291 12.9117 17.2213 13.2452 17.0447C13.5692 16.878 13.9313 16.6818 14.322 16.878C15.1511 17.2899 15.0939 19.1337 14.4936 20.4382C13.979 21.5464 13.1118 22.1839 12.4733 22.5174C12.4352 22.5174 12.378 22.537 12.3209 22.537Z"
      fill="#7D662D"
    />
    <path
      d="M11.2063 9.94566H4.53571C4.33559 9.94566 4.16406 9.77893 4.16406 9.56316C4.16406 9.34739 4.32606 9.18066 4.53571 9.18066H11.2063C11.4065 9.18066 11.578 9.34739 11.578 9.56316C11.578 9.77893 11.416 9.94566 11.2063 9.94566Z"
      fill="#7D662D"
    />
    <path
      d="M11.2063 16.8099H4.53571C4.33559 16.8099 4.16406 16.6432 4.16406 16.4274C4.16406 16.2215 4.32606 16.0449 4.53571 16.0449H11.2063C11.4065 16.0449 11.578 16.2117 11.578 16.4274C11.578 16.6432 11.416 16.8099 11.2063 16.8099Z"
      fill="#7D662D"
    />
    <path
      d="M20.1077 22.5374C20.0506 22.5374 19.9934 22.5276 19.9362 22.4982C19.2977 22.1647 18.4306 21.5272 17.916 20.419C17.3156 19.1146 17.2584 17.2805 18.0875 16.8588C18.4782 16.6626 18.8403 16.8588 19.1643 17.0255C19.4979 17.2021 19.7361 17.3099 19.9839 17.2217C20.2602 17.1236 20.4222 16.8196 20.5175 16.6332C21.2608 15.2405 21.48 11.3567 20.6986 9.56193C20.5652 9.25789 20.3365 8.86558 20.0125 8.78712C19.8123 8.73808 19.6885 8.53213 19.7361 8.32617C19.7837 8.12021 19.9839 7.99271 20.184 8.04175C20.6795 8.15944 21.0798 8.56155 21.3752 9.24808C22.2614 11.2881 22.0041 15.4073 21.1655 16.9961C21.0416 17.2413 20.7653 17.7415 20.2221 17.9376C19.6599 18.1338 19.1834 17.8886 18.8308 17.7022C18.6974 17.6336 18.4687 17.5159 18.4115 17.5355C18.1923 17.6434 18.0494 18.9086 18.583 20.0757C19.0023 20.9976 19.7361 21.5272 20.2698 21.8116C20.4508 21.9097 20.527 22.1353 20.4317 22.3216C20.365 22.4589 20.2412 22.5374 20.1077 22.5374Z"
      fill="#7D662D"
    />
    <path
      d="M18.6197 8.4239C18.4672 8.4239 18.3243 8.32583 18.2671 8.1591C17.4762 5.70719 19.3344 3.81432 19.9348 3.50048C20.1158 3.4024 20.3445 3.48086 20.4303 3.66721C20.5256 3.85355 20.4494 4.08893 20.2683 4.1772C20.0015 4.31451 18.2957 5.82488 18.9723 7.91391C19.039 8.11006 18.9342 8.32583 18.7341 8.39448C18.6959 8.4141 18.6578 8.4239 18.6197 8.4239Z"
      fill="#7D662D"
    />
    <path
      d="M27.8821 9.94566H21.2115C21.0114 9.94566 20.8398 9.77893 20.8398 9.56316C20.8398 9.34739 21.0018 9.18066 21.2115 9.18066H27.8821C28.0822 9.18066 28.2538 9.34739 28.2538 9.56316C28.2538 9.77893 28.0918 9.94566 27.8821 9.94566Z"
      fill="#7D662D"
    />
    <path
      d="M27.8821 16.8099H21.2115C21.0114 16.8099 20.8398 16.6432 20.8398 16.4274C20.8398 16.2215 21.0018 16.0449 21.2115 16.0449H27.8821C28.0822 16.0449 28.2538 16.2117 28.2538 16.4274C28.2538 16.6432 28.0918 16.8099 27.8821 16.8099Z"
      fill="#7D662D"
    />
  </svg>
);

export const DollarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C9.125 0 10.125 0.65625 10.625 1.625C11.6562 1.28125 12.8438 1.53125 13.6562 2.34375C14.4688 3.15625 14.7188 4.34375 14.375 5.375C15.3438 5.875 16 6.875 16 8C16 9.15625 15.3438 10.1562 14.375 10.6562C14.7188 11.6875 14.4688 12.8438 13.6562 13.6562C12.8438 14.4688 11.6562 14.7188 10.625 14.4062C10.125 15.375 9.125 16 8 16C6.84375 16 5.84375 15.375 5.34375 14.4062C4.3125 14.7188 3.15625 14.4688 2.34375 13.6562C1.53125 12.8438 1.28125 11.6875 1.59375 10.6562C0.625 10.1562 0 9.15625 0 8C0 6.875 0.625 5.875 1.59375 5.375C1.28125 4.34375 1.53125 3.15625 2.34375 2.34375C3.15625 1.53125 4.3125 1.28125 5.34375 1.625C5.84375 0.65625 6.84375 0 8 0ZM8.625 4.40625C8.625 4.0625 8.34375 3.78125 8 3.78125C7.65625 3.78125 7.375 4.0625 7.375 4.40625V4.9375C7.125 5 6.84375 5.09375 6.59375 5.25C6.125 5.53125 5.71875 6 5.71875 6.71875C5.71875 7.375 6.125 7.8125 6.53125 8.0625C6.90625 8.28125 7.375 8.4375 7.78125 8.5625H7.8125C8.25 8.6875 8.59375 8.8125 8.8125 8.9375C9 9.0625 9.0625 9.15625 9.0625 9.28125C9.0625 9.5 8.96875 9.625 8.8125 9.71875C8.625 9.84375 8.34375 9.90625 8.03125 9.90625C7.625 9.875 7.25 9.75 6.78125 9.59375C6.71875 9.5625 6.625 9.53125 6.53125 9.5C6.21875 9.40625 5.875 9.5625 5.75 9.90625C5.65625 10.2188 5.8125 10.5938 6.15625 10.6875C6.21875 10.7188 6.28125 10.75 6.34375 10.75C6.65625 10.875 7 11 7.375 11.0625V11.625C7.375 11.9688 7.65625 12.25 8 12.25C8.34375 12.25 8.625 11.9688 8.625 11.625V11.0938C8.9375 11.0312 9.21875 10.9375 9.46875 10.7812C9.9375 10.4688 10.3125 9.96875 10.3125 9.28125C10.2812 8.59375 9.90625 8.15625 9.46875 7.875C9.09375 7.625 8.59375 7.5 8.1875 7.375C7.75 7.21875 7.40625 7.125 7.1875 7C7 6.875 6.96875 6.8125 6.96875 6.71875C6.96875 6.53125 7.03125 6.4375 7.21875 6.3125C7.40625 6.1875 7.71875 6.125 8 6.125C8.34375 6.15625 8.71875 6.21875 9.09375 6.3125C9.4375 6.40625 9.78125 6.21875 9.875 5.875C9.9375 5.53125 9.75 5.1875 9.40625 5.125C9.1875 5.03125 8.90625 4.96875 8.625 4.9375V4.40625Z"
      fill="url(#paint0_linear_8999_23180)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8999_23180"
        x1="8"
        y1="-2"
        x2="8"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stop-color="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const EmailIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.875 9.8125L3 4.71875C3.15625 3.75 3.96875 3 5 3H16C17 3 17.8125 3.75 17.9688 4.71875L11.0938 9.8125C10.9062 9.9375 10.6875 10 10.5 10C10.2812 10 10.0625 9.9375 9.875 9.8125ZM11.6875 10.625L18 5.9375V12C18 13.125 17.0938 14 16 14H5C3.875 14 3 13.125 3 12V5.9375L9.28125 10.625C9.625 10.875 10.0625 11 10.5 11C10.9062 11 11.3438 10.875 11.6875 10.625ZM1.5 5.75V12.75C1.5 14.2812 2.71875 15.5 4.25 15.5H14.25C14.6562 15.5 15 15.8438 15 16.25C15 16.6875 14.6562 17 14.25 17H4.25C1.875 17 0 15.125 0 12.75V5.75C0 5.34375 0.3125 5 0.75 5C1.15625 5 1.5 5.34375 1.5 5.75Z"
      fill="url(#paint0_linear_8999_23188)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8999_23188"
        x1="9"
        y1="0"
        x2="9"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stop-color="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const SpecialOfferStarIcon = () => (
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5.21484C0 3.4375 0.9375 1.79688 2.5 0.898438C4.04297 0 5.9375 0 7.5 0.898438C9.04297 1.79688 10 3.4375 10 5.21484C10 7.01172 9.04297 8.65234 7.5 9.55078C5.9375 10.4492 4.04297 10.4492 2.5 9.55078C0.9375 8.65234 0 7.01172 0 5.21484ZM5 2.24609C4.86328 2.24609 4.76562 2.32422 4.70703 2.42188L4.00391 3.86719L2.42188 4.10156C2.30469 4.10156 2.20703 4.19922 2.16797 4.29688C2.12891 4.41406 2.16797 4.55078 2.24609 4.62891L3.39844 5.74219L3.125 7.32422C3.10547 7.44141 3.14453 7.55859 3.24219 7.61719C3.33984 7.69531 3.47656 7.69531 3.57422 7.65625L5 6.91406L6.40625 7.65625C6.50391 7.69531 6.64062 7.69531 6.73828 7.61719C6.83594 7.55859 6.875 7.44141 6.85547 7.32422L6.60156 5.74219L7.73438 4.62891C7.83203 4.55078 7.85156 4.41406 7.8125 4.31641C7.77344 4.19922 7.67578 4.12109 7.55859 4.10156L5.97656 3.86719L5.27344 2.42188C5.21484 2.32422 5.11719 2.26562 5 2.26562V2.24609Z"
      fill="white"
    />
  </svg>
);
